import { useCallback, useContext } from 'react'
import { ModalContext } from './ModalProvider'

export const useModal = (ModalComponent) => {
  const { openModal } = useContext(ModalContext)

  return useCallback(
    (data) => {
      return openModal(ModalComponent, data)
    },
    [ModalComponent, openModal],
  )
}
